import Banner from "../../components/ourWork/banner";
import Contact from "../../components/commonComponents/contact";

const OurWork = () => {
  return (
    <div className="homepage-container pt-20 lg:pt-0">
      <Banner />
      <Contact />
    </div>
  );
};
export default OurWork;
